import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedDate: "",
  visibleCalendar: false,
  visibleRangeCalendar: false,
  disablePreviousDates: false,
  filterDates: false,
  availableDates: [],
};

export const datepickerSlice = createSlice({
  name: "datepicker",
  initialState,
  reducers: {
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setVisibleCalendar: (state, action) => {
      state.visibleCalendar = action.payload;
    },
    setVisibleRangeCalendar: (state, action) => {
      state.visibleRangeCalendar = action.payload;
    },
    setDisablePreviousDates: (state, action) => {
      state.disablePreviousDates = action.payload;
    },
    setFilterDates: (state, action) => {
      state.filterDates = action.payload;
    },
    setAvailableDates: (state, action) => {
      state.availableDates = action.payload;
    },
  },
});

export const getSelectedDate = (state) => state.datepicker.selectedDate;
export const getVisibleCalendar = (state) => state.datepicker.visibleCalendar;
export const getVisibleRangeCalendar = (state) => state.datepicker.visibleRangeCalendar;
export const getDisablePreviousDates = (state) => state.datepicker.disablePreviousDates;
export const getAvailableDates = (state) => state.datepicker.availableDates;
export const getFilterDates = (state) => state.datepicker.filterDates;

export const { setSelectedDate, setVisibleCalendar, setVisibleRangeCalendar, setDisablePreviousDates, setAvailableDates, setFilterDates } =
  datepickerSlice.actions;

export default datepickerSlice.reducer;
